<template>
    <div class="patient-edit-original">
        <bread-crumb :bread-list="breadList" />
        <div class="edit-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">编辑原创</span>
            </div>
            <el-form :model="originalDetails"
                     ref="originalDetails"
                     v-loading="loading"
                     label-width="104px"
                     class="original-form">
                <el-form-item label="新标题"
                              prop="title"
                              :rules="[{ required: true, message: '请输入新标题', trigger: 'change' }]">
                    <el-input v-model.trim="originalDetails.title"
                              class="from-input"
                              placeholder="请输入URL"
                              maxlength="15">
                    </el-input>
                </el-form-item>

                <el-form-item label="封面图"
                              prop="coverPicture"
                              :rules="[{ required: true, message: '请上传封面图', trigger: 'change' }]">
                    <div v-if="originalDetails.coverPicture"
                         class="cover-content">
                        <el-image fit="fill"
                                  class="cover-picture"
                                  :src="'/ms-hoc-video/v1/image/download?fileName='+ originalDetails.coverPicture">
                        </el-image>
                        <i class="iconfont icon-jinggaochacha"
                           @click="handleRemove"></i>
                    </div>

                    <el-upload v-else
                               v-loading="pictureLoading"
                               class="picture-uploader"
                               :action="uploadAction"
                               :show-file-list="false"
                               accept=".jpg, .png"
                               :on-success="handleSuccess"
                               :before-upload="beforeUpload">
                        <div class="picture-content">
                            <i class="iconfont icon-camera"></i>
                            <div class="picture_text">
                                上传封面图
                            </div>
                        </div>
                    </el-upload>
                    <h1 class="uploader-tips">
                        建议图片小于2M，尺寸：698*280，图片格式为JPG、PNG。
                    </h1>
                </el-form-item>

                <el-form-item label="推送日期"
                              prop="addedTime"
                              :rules="[{ required: true, message: '请输入推送日期', trigger: 'change' }]">
                    <el-date-picker size="small"
                                    clearable
                                    v-model="originalDetails.addedTime"
                                    type="datetime"
                                    placeholder="yyyy-MM-dd HH:mm"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    :style="{width: '320px'}">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="内容简介"
                              prop="url">
                    <div class="detail-wrap">
                        <quill-editor v-model="content"
                                      ref="myQuillEditor"
                                      :options="editorOption.options"
                                      @blur="onEditorBlur($event)"
                                      @focus="onEditorFocus($event)"
                                      @ready="onEditorReady($event)"></quill-editor>
                    </div>

                    <!-- 文本编辑器中的图片视频等上传 -->
                    <el-upload class="avatar-uploader"
                               :action="editorOption.serverUrl"
                               multiple
                               name="img"
                               ref="uploadImg"
                               :headers="editorOption.header"
                               accept=".jpg, .jpeg, .png, .gif, .bmp"
                               :show-file-list="false"
                               :before-upload="beforeUploadImg"
                               :http-request="uploadLoad"
                               style="display:none;"></el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary"
                               class="submit-btn"
                               @click="submitForm('originalDetails')">提交</el-button>
                    <el-button @click="handleCandle"
                               class="cancle-btn">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { Quill, quillEditor } from 'vue-quill-editor'

// 这里引入修改过的video模块并注册
import Video from '@/utils/quill/video'
import Audio from '@/utils/quill/audio'
import { mapGetters } from 'vuex'
import { postContentUpdate, uploadImgList, getByContentId } from '@/api/patient/content'

Quill.register(Video, true)
Quill.register(Audio, true)
export default {
    name: 'editOriginal',
    data () {
        const toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction

            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ['link', 'image', 'video', 'audio'],
            ['clean'] // remove formatting button
        ]
        return {
            breadList: [{ label: '内容管理' }, { label: '内容列表', path: '/patient/content/contentList' }, { label: '编辑原创' }],
            loading: false,
            pictureLoading: false,
            content: '',
            // 富文本编辑
            editorOption: {
                serverUrl: '/up',
                header: {},
                options: {
                    placeholder: '',
                    theme: 'snow', // or 'bubble'
                    modules: {
                        toolbar: {
                            container: toolbarOptions, // 工具栏
                            handlers: {
                                image: function (value) {
                                    if (value) {
                                        document.querySelector('.avatar-uploader input').click()
                                    } else {
                                        this.quill.format('image', false)
                                    }
                                },
                                video: function (value) {
                                    if (value) {
                                        document.querySelector('.uploader-video input').click()
                                    } else {
                                        this.quill.format('video', false)
                                    }
                                },
                                audio: function (value) {
                                    if (value) {
                                        document.querySelector('.uploader-audio input').click()
                                    } else {
                                        this.quill.format('audio', false)
                                    }
                                }
                            }
                        }
                    }
                },
                uploadForm: [],
                formIndex: -1
            },
            originalDetails: {},
            contentId: this.$route.query.contentId
        }
    },
    components: {
        quillEditor
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ]),
        uploadAction () {
            return `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=PATIENTCONTENT`
        }
    },
    methods: {
        onEditorBlur (quill) {
            // console.log('editor blur!', quill)
        },
        onEditorFocus (quill) {
            // console.log('editor focus!', quill)
        },
        onEditorReady (quill) {
            // console.log('editor ready!', quill)
        },
        beforeUploadImg (file) {
            const isType = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
            const fileName = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() // 文件扩展名
            const isLt2M = file.size / 1024 / 1024 < 5

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过5MB!')
                return false
            } else if (!isType.includes(fileName)) {
                this.$message.error('请上传' + isType.join(',') + '的文件!')
            } else {
                const form = new FormData()
                this.editorOption.uploadForm.push(form)
                this.editorOption.formIndex++
                this.editorOption.uploadForm[this.editorOption.formIndex].append('file', file)
                console.log(this.editorOption.uploadForm[this.editorOption.formIndex])
            }
        },
        uploadLoad () {
            const param = {
                hospitalId: this.userInfo.hospitalId,
                iuid: this.userInfo.iuid
            }
            uploadImgList(param, this.editorOption.uploadForm[this.editorOption.formIndex]).then(res => {
                const quill = this.$refs.myQuillEditor.quill
                // 如果上传成功
                if (res.results) {
                    // 获取光标所在位置
                    const length = quill.getSelection().index
                    res.results.forEach(item => {
                        const url = '/ms-hoc-video/v1/image/download?fileName=' + item.originPictureId
                        // 插入图片  res.info为服务器返回的图片地址
                        quill.insertEmbed(length, 'image', url)
                        // 调整光标到最后
                        quill.setSelection(length + 1)
                    })
                } else {
                    this.$message.error('图片插入失败')
                }
            })
        },
        handleCandle () {
            this.$router.push('/patient/content/contentList')
        },
        beforeUpload (file) {
            this.pictureLoading = true
            const isType = ['jpg', 'jpeg', 'png']
            const fileName = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() // 文件扩展名
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过2MB!')
                this.pictureLoading = false
                return false
            } else if (!isType.includes(fileName)) {
                this.$message.error('请上传' + isType.join(',') + '的文件!')
                this.pictureLoading = false
                return false
            } else {
                return true
            }
        },
        handleSuccess (res, file) {
            const data = res.results
            if (data && data.length > 0) {
                this.originalDetails.coverPicture = data[0].originPictureId
                this.$refs.originalDetails.clearValidate()
            } else {
                this.$message.error('上传出错，请检查上传图片！')
            }
            this.pictureLoading = false
        },
        handleRemove () {
            this.originalDetails.coverPicture = ''
            this.pictureLoading = false
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.hanleSave()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async hanleSave () {
            // 聚焦富文本，插入一个空格，避免只有音视频时无法删除富文本中内容
            let quill = this.$refs.myQuillEditor.quill
            quill.focus()
            let length = quill.getSelection().index
            quill.insertText(length, ' ', true)
            this.content = this.content.replace(/"/g, '\'')
            let addedTime = this.originalDetails.addedTime
            if (this.originalDetails.addedTime.length !== 19) {
                addedTime = addedTime + ':00'
            }

            let params = {
                contentId: this.contentId,
                addedTime: addedTime,
                contentType: 'ORIGINAL',
                coverPicture: this.originalDetails.coverPicture,
                title: this.originalDetails.title,
                uploader: this.userInfo.accountName,
                content: this.content
            }
            this.loading = true
            const { results } = await postContentUpdate(params)
            if (results) {
                this.$message({
                    message: '新增原创成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.$router.push('/patient/content/contentList')
            } else {
                this.$message.error('新增原创失败，请联系管理员！')
            }
            this.loading = false
        },
        async queryContent () {
            this.loading = true
            const { results } = await getByContentId(this.contentId)
            this.originalDetails = results
            this.content = results.content
            this.loading = false
        }

    },
    mounted () {
        this.queryContent()
    }
}
</script>

<style lang="scss">
.patient-edit-original {
    height: 100%;
    .edit-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .title-wrap {
            padding-bottom: 10px;
            height: 16px;
            line-height: 16px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #ccc;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                height: 16px;
                font-family: PingFangSC-Medium;
            }
        }

        .original-form {
            margin-top: 20px;
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                padding-right: 20px;
            }
            .el-form-item__content {
                .detail-wrap {
                    margin-left: 0;
                    width: 692px;
                    height: 292px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    overflow: auto;
                }
                .ql-editor {
                    .detail-wrap {
                        top: 0;
                        font-size: 13px;
                    }
                }
                .quill-editor {
                    width: 100%;
                    height: 100%;
                    position: relative;
                }
                .ql-picker {
                    height: 42px;
                }
                .ql-container {
                    position: absolute;
                    right: 0;
                    left: 0;
                    top: 102px;
                    bottom: 0;
                    height: auto;
                }
                .ql-tooltip {
                    left: 20px !important;
                }
                .from-input {
                    width: 320px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                    }
                }
                .cover-content {
                    position: relative;
                    .cover-picture {
                        width: 339px;
                        height: 130px;
                    }
                    .icon-jinggaochacha {
                        cursor: pointer;
                        font-size: 16px;
                        color: #ec6a69;
                        position: absolute;
                        top: -15px;
                        left: 330px;
                    }
                }

                .picture-uploader {
                    width: 327px;
                    height: 130px;
                    background: #d8d8d8;
                    text-align: center;
                    .picture-content {
                        margin-top: 40px;
                        .icon-camera {
                            font-size: 24px;
                            color: #fff;
                        }
                        .picture_text {
                            margin-top: 2px;
                            font-family: PingFang-SC-Medium;
                            font-size: 14px;
                            color: #ffffff;
                            letter-spacing: 0;
                            line-height: 14px;
                        }
                    }
                }
                .uploader-tips {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 16px;
                    font-weight: normal;
                    margin-top: 10px;
                }
                .form-datetime {
                    width: 320px;
                    .el-input__inner {
                        height: 32px;
                    }
                    .el-input__prefix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                }
                .submit-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    margin-bottom: 50px;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    color: #666;
                    margin-left: 16px;
                    margin-bottom: 50px;
                }
            }
        }
    }
}
</style>
